// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1GEV1","modalForm":"UpgradeEpcsModal_modalForm__1gkj4","modalFooter":"UpgradeEpcsModal_modalFooter__nJ4ZB"};